<template>
    <div class="page-main-title">
        <div class="title" v-if="$route.meta.title">{{ $route.meta.title }}</div>
    </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.page-main-title {
    padding: 40px 40px 0;
    font-size: 24px;
    color: $-text-950;
    line-height: 24px;
    font-weight: 600;
    border-radius: 10px 10px 0 0;
    background-color: $--color-white;
    overflow: hidden;
    position: relative;
}

.page-main-title-right {
    position: absolute;
    right: 40px;
    top: -34px;
    font-size: 20px;
    color: $-text-500;
    line-height: 20px;
    height: 44px;
    line-height: 44px;
}
</style>
